import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, ArrowRight } from "lucide-react";
import { track } from "../lib/track";

const MAIN_SITE = "https://equitashomes.com";
const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_home-value-estimate/artifacts/tkfajn1r_EQ1%24FAVICON.png";

export const Logo = ({ light = false }) => (
  <a href={MAIN_SITE} className="flex items-center gap-2 group shrink-0 whitespace-nowrap" data-testid="brand-logo-link">
    <img src={LOGO_URL} alt="Equitas 1%" className={`h-10 w-10 rounded-full shrink-0 ${light ? "ring-1 ring-brand-cream/30" : ""}`} />
    {light ? (
      <span data-testid="brand-wordmark" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600 }}
        className="text-[1.9rem] lowercase leading-none tracking-[-0.01em] text-brand-cream">
        equitas
      </span>
    ) : (
      <img data-testid="brand-wordmark" src="/equitas-wordmark.png" alt="equitas" className="h-7 w-auto" />
    )}
  </a>
);

export const AnnouncementBar = () => (
  <Link
    to="/2-percent-direct-sale"
    data-testid="direct-sale-announcement-bar"
    className="group block bg-brand-emerald text-brand-cream hover:bg-brand-emeraldHover transition-colors"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-2 flex items-center justify-center gap-2 text-center">
      <span className="inline-flex items-center justify-center rounded-full bg-brand-gold/90 px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-[0.18em] text-brand-dark">
        New
      </span>
      <span className="text-xs sm:text-sm leading-tight">
        Got an offer from an unrepresented buyer? Sell for just{" "}
        <strong className="font-semibold text-brand-gold">2% total</strong> with our Direct Sale program
      </span>
      <ArrowRight className="h-3.5 w-3.5 shrink-0 transition-transform group-hover:translate-x-0.5" />
    </div>
  </Link>
);

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <>
    <AnnouncementBar />
    <header data-testid="header-nav" className="sticky top-0 z-50 backdrop-blur-md bg-brand-cream/85 border-b border-brand-hairline/70">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-[68px] flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-brand-ink">
          <Link to="/selling-costs" className="hover:text-brand-emerald transition-colors" data-testid="nav-selling-costs">Selling Costs</Link>
          <Link to="/how-it-works" className="hover:text-brand-emerald transition-colors" data-testid="nav-how-it-works">How It Works</Link>
          <Link to="/services" className="hover:text-brand-emerald transition-colors" data-testid="nav-services">What We Do</Link>
          <Link to="/2-percent-direct-sale" className="hover:text-brand-emerald transition-colors" data-testid="nav-direct-sale">2% Direct Sale</Link>
          <Link to="/blog" className="hover:text-brand-emerald transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/about" className="hover:text-brand-emerald transition-colors" data-testid="nav-about">About</Link>
          <Link to="/contact" onClick={() => track("contact_click", { channel: "nav-contact" })} className="hover:text-brand-emerald transition-colors" data-testid="nav-contact">Contact</Link>
          <a href="tel:+14085611321" onClick={() => track("contact_click", { channel: "phone" })} className="flex items-center gap-1.5 hover:text-brand-emerald transition-colors" data-testid="nav-phone">
            <Phone className="h-3.5 w-3.5" /> (408) 561-1321
          </a>
        </nav>
        <button className="md:hidden p-2 text-brand-emerald" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-brand-hairline bg-brand-cream px-5 py-4 flex flex-col gap-4 text-sm font-medium">
          <Link to="/selling-costs" onClick={() => setOpen(false)} data-testid="mobile-nav-selling-costs">Selling Costs</Link>
          <Link to="/how-it-works" onClick={() => setOpen(false)} data-testid="mobile-nav-how-it-works">How It Works</Link>
          <Link to="/2-percent-direct-sale" onClick={() => setOpen(false)} data-testid="mobile-nav-direct-sale">2% Direct Sale</Link>
          <Link to="/blog" onClick={() => setOpen(false)} data-testid="mobile-nav-blog">Blog</Link>
          <Link to="/about" onClick={() => setOpen(false)} data-testid="mobile-nav-about">About</Link>
          <Link to="/contact" onClick={() => setOpen(false)} data-testid="mobile-nav-contact">Contact</Link>
          <a href="tel:+14085611321">(408) 561-1321</a>
        </div>
      )}
    </header>
    </>
  );
}
